import { Dialog, Transition } from '@headlessui/react'
import React, { Fragment, useState } from 'react'
import ReactDOM from 'react-dom'

export interface ModalProps {
    title?: string | React.ReactChildren
    isOpen: boolean
    content: string | React.ReactElement | JSX.Element
    closeModal: () => void
    buttonContent?: string | React.ReactChildren
    buttonClick?: () => void
    className?: string
}

export const Modal = ({ title, isOpen, content, closeModal, className }: ModalProps) => {
    return isOpen
        ? (ReactDOM.createPortal(
              <>
                  <Transition appear show={isOpen} as={Fragment}>
                      <Dialog
                          as="div"
                          className={`${className} fixed inset-0 z-[999] overflow-y-auto drop-shadow-lg`}
                          onClose={closeModal}
                      >
                          <div className="min-h-screen px-4 text-center">
                              <Transition.Child
                                  as={Fragment}
                                  enter="ease-out duration-300"
                                  enterFrom="opacity-0"
                                  enterTo="opacity-100"
                                  leave="ease-in duration-200"
                                  leaveFrom="opacity-100"
                                  leaveTo="opacity-0"
                              >
                                  <Dialog.Overlay className="fixed inset-0" />
                              </Transition.Child>

                              {/* This element is to trick the browser into centering the modal contents. */}
                              <span
                                  className="inline-block h-screen align-middle"
                                  aria-hidden="true"
                              >
                                  &#8203;
                              </span>
                              <Transition.Child
                                  as={Fragment}
                                  enter="ease-out duration-300"
                                  enterFrom="opacity-0 scale-95"
                                  enterTo="opacity-100 scale-100"
                                  leave="ease-in duration-200"
                                  leaveFrom="opacity-100 scale-100"
                                  leaveTo="opacity-0 scale-95"
                              >
                                  <div className="inline-block w-full max-w-lg p-6 my-8 overflow-hidden text-left align-middle transition-all transform bg-white shadow-xl rounded-2xl">
                                      {title && (
                                          <Dialog.Title
                                              as="h3"
                                              className="text-lg font-medium leading-6 text-gray-900"
                                          >
                                              {title}
                                          </Dialog.Title>
                                      )}
                                      <div className="mt-2">{content}</div>
                                  </div>
                              </Transition.Child>
                          </div>
                      </Dialog>
                  </Transition>
              </>,
              document.body
          ) as JSX.Element)
        : (null as JSX.Element)
}
const useModal = () => {
    const [isOpen, setIsOpen] = useState(false)

    function toggle() {
        setIsOpen(!isOpen)
    }
    function closeModal() {
        setIsOpen(false)
    }

    return {
        isOpen,
        toggle,
        closeModal,
        Modal
    }
}

export default useModal
